<template>
  <fts-design-modal
    full-screen
    class="fts-script-editor-modal"
    ref="ftsDesignModal"
    @closed="reset"
  >
    <!-- title -->
    <template #title>
      <div class="design-modal-header-std__title">
        <font-awesome-icon :icon="['fas', 'code']" class="design-modal-header-icon" />
        <div class="design-modal-header-name">{{option.title}} <fts-release-badge alpha class="fts-align-top" /></div>
      </div>
    </template>
    <!-- description -->
    <template #description>
      <span class="design-modal-header-tag">Script Editor</span>
      <span class="design-modal-header-description">
        {{option.description}}
      </span>
    </template>
    <!-- body -->
    <template #body>
      <fts-script-editor
        editor-id="scripttest"
        v-model="formData"
        :lang="lang"
        full-height
        disabled-header
        disabled-dictionary
      >
      </fts-script-editor>
    </template>
    <!-- footer:right -->
    <template #footerRight="{ beforeClose }">
        <fts-btn text @click="beforeClose">
          Cancel
        </fts-btn>

        <fts-btn color="primary" outline @click="done">
          <font-awesome-icon :icon="['fas', 'check']" /> Ok
        </fts-btn>
    </template>
  </fts-design-modal>
</template>

<script>
import changesets from "diff-json";

import FTSBtn from '../elements/FTSBtn';
import FTSDesignModal from './FTSDesignModal';
import FTSReleaseBadge from '../elements/FTSReleaseBadge';
import FTSScriptEditor from './FTSScriptEditor';

export default {
  components: {
    "fts-btn": FTSBtn,
    "fts-design-modal": FTSDesignModal,
    "fts-release-badge": FTSReleaseBadge,
    "fts-script-editor": FTSScriptEditor
  },
  data: () => ({
    originalData: null,
    resolve: null,
    formData: null,
    option: {},
    lang: 'json'
  }),
  methods: {
    async show(formData, option) {
      if (option.mode == 'schema') {
        this.lang = 'yaml';
      }

      return new Promise(async (resolve) => {
        this.resolve = resolve;
        this.formData = _.cloneDeep(formData);
        this.option = {
          title: option.title || "Script Editor",
          description: option.description || "First solve the problem then write the code.",
        };
        this.$refs.ftsDesignModal.show({
          beforeCloseHandler: async () => {
            const diff = changesets.diff(this.formData, this.originalData);
            if (diff && diff.length) {
              const res = await this.$confirmation.show({
                text: 'Are you sure you want to discard changes?'
              });

              if (res == true) {
                this.$refs.ftsDesignModal.close();
              }
            } else {
              this.$refs.ftsDesignModal.close();
            }
          }
        });
        this.$nextTick(() => {
          this.originalData = _.cloneDeep(this.formData);
        });
      });
    },
    done() {
      this.resolve && this.resolve(this.formData);
      this.$refs.ftsDesignModal.close();
    },
    reset() {
      Object.assign(this.$data, this.$options.data.apply(this));
    }
  }
}
</script>